module.exports = __webpack_public_path__ + "img/banner4.ce4bd080.png";